import { MdOutlineLocationCity } from "react-icons/md";
import { GiModernCity } from "react-icons/gi";
export const TargetMenu = [
  {
    id: "1",
    name: "تارگت کل",
    path: `SetHollTarget`,
    icon: <MdOutlineLocationCity size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "تارگت شخص",
    path: `SetPersonTarget`,
    icon: <GiModernCity size={25} />,
    color: "#f1416c",
    type: "menu",
  },
];
